//
import GBranchOfficeModel from '@/models/General/GBranchOffice'
import { required } from '@/services/validations'

//
export default [
  {
    name: "g_branch_office_id",
    type: "autocomplete-model",
    props: {
      itemText: "name",
      itemValue: "id",
      noObject: true,
      label: "Sucursal",
      model: GBranchOfficeModel,
      paramSearch: "name",
      rules: [ required ],
    }
  },
  {
    name: "number",
    type: "text-field",
    props: {
      label: "Numero",
      rules: [ required ],
    }
  },
  {
    name: "name",
    type: "text-field",
    props: {
      label: "Nombre",
      rules: [ required ],
    }
  },
]